// File: src/modules/auth/setupRecaptcha.js

let recaptchaWidgetId = null;
let resolveCallback = null;

export function setupRecaptcha() {
  return {
    render: () => {
      const container = document.getElementById('recaptcha-container');
      if (!container) return;

      if (recaptchaWidgetId !== null && container.innerHTML.trim() !== '') {
        container.innerHTML = '';
        recaptchaWidgetId = null;
      }

      window.recaptchaVerified = function(token) {
        if (resolveCallback) {
          resolveCallback(token);
          resolveCallback = null;
        }
      };

      recaptchaWidgetId = window.grecaptcha.render('recaptcha-container', {
        sitekey: '6LeQIy0rAAAAAOJ0iH1PYuprOrXw90ecVJ584EG0',
        size: 'normal',
        theme: 'light',
        callback: 'recaptchaVerified',
      });
    },

    reset: () => {
      if (recaptchaWidgetId !== null) {
        window.grecaptcha.reset(recaptchaWidgetId);
      }
    },

    destroy: () => {
      const container = document.getElementById('recaptcha-container');
      if (container) container.innerHTML = '';
      recaptchaWidgetId = null;
      resolveCallback = null;
    },

    verify: () => {
      return new Promise((resolve, reject) => {
        const token = window.grecaptcha.getResponse(recaptchaWidgetId);
        if (token) {
          resolve(token);
        } else {
          resolveCallback = resolve;

          // Optional: Add a timeout fallback
          setTimeout(() => {
            if (resolveCallback) {
              reject(new Error('❌ Captcha timeout. Please try again.'));
              resolveCallback = null;
            }
          }, 30000); // 30 seconds timeout
        }
      });
    },
  };
}
